import React from "react";
import ReactDOM from "react-dom";
import { QueryClientProvider, QueryClient } from 'react-query';
import { ChakraProvider,ColorModeScript } from "@chakra-ui/react";
import Web3Provider from "./services/Web3Provider";

import App from "./App";
import customTheme from "./utils/theme";
import "@fontsource/abel/400.css";
import "@fontsource/jura/400.css";
import "./styles.css"

const queryClient = new QueryClient();

const rootElement = document.getElementById("root");
ReactDOM.render(
    <React.StrictMode>
        
            <QueryClientProvider client={queryClient}>
                {/* <Web3ReactProvider connectors={connectors}> */}
                <Web3Provider />
                    <ChakraProvider theme={customTheme}>
                        <ColorModeScript initialColorMode={customTheme.initialColorMode} />
                        <App />
                        {/* <span id="siteseal"><script async type="text/javascript" src="https://seal.godaddy.com/getSeal?sealID=02Cb1LNAQ9iot3qk7lyDKgvsJ27WMyobHFTSbPGY7AD6MvjMpkaE8ma1PtZF"></script></span> */}
                    </ChakraProvider>
                {/* </Web3ReactProvider> */}
            </QueryClientProvider>
        
    </React.StrictMode>,
    rootElement
);